import React, { Component } from 'react'
import PropType from 'prop-types'
import { reduxForm } from 'redux-form'

import { extractNumber } from '@cred/shared/utils'

import Dropdown from 'components/dropdown'
import MoneyInput from 'components/money-input'
import SubmitButton from 'components/submit-button'
import { loanPurposeOptions } from 'components/dropdown/dropdown-options'
import { validateLoanAmount } from 'common/validations/loan-amount'
import { fireGtmEvent } from 'utils/gtm'
import PoweredBy from 'components/powered-by'

import styles from './styles.module.scss'

class PersonalLoanForm extends Component {
  constructor(props) {
    super(props)

    const { href } = this.props

    this.state = {
      url: href,
      loanAmount: null,
      loanPurpose: null,
    }
  }

  render() {
    const { ctaText, formData } = this.props
    const { url, loanAmount } = this.state

    return (
      <>
        <section className={styles.form}>
          <div className="loan-amount mb-8">
            <MoneyInput
              name="loanAmount"
              label="Loan amount"
              placeholder="Loan amount"
              validate={[validateLoanAmount]}
              onChange={this.onLoanAmountChange}
              exposeValue
            />
          </div>
          <div className="loan-purpose mb-16">
            <Dropdown
              name="loanPurpose"
              label="Loan purpose"
              placeholder="Loan purpose"
              options={loanPurposeOptions}
              onChange={this.onLoanPurposeChange}
            />
          </div>
        </section>
        <section className={styles.submit}>
          <SubmitButton
            href={url}
            onClick={this.onClick}
            blank
            fullWidth
            formData={formData}
            hasIcon={false}
            analyticsOptions={{ text: ctaText, activated: !validateLoanAmount(loanAmount) }}
          >
            {ctaText}
          </SubmitButton>
          <PoweredBy className="mt-8" />
        </section>
      </>
    )
  }

  onLoanAmountChange = (evt) => {
    const { widgetContext, href } = this.props
    const { loanPurpose } = this.state
    const { value } = evt.target

    if (validateLoanAmount(value)) {
      this.setState({
        url: '',
        loanAmount: value,
      })
    } else {
      this.setState({
        url: loanPurpose
          ? `${href}&loanAmount=${extractNumber(value)}&loanPurpose=${loanPurpose}`
          : `${href}&loanAmount=${extractNumber(value)}`,
        loanAmount: value,
      })
    }

    fireGtmEvent('fieldChange', { ...widgetContext, loanAmount: value })
  }

  onLoanPurposeChange = (evt) => {
    const { widgetContext, href } = this.props
    const { loanAmount } = this.state
    const { value } = evt.target

    if (validateLoanAmount(loanAmount)) {
      this.setState({
        url: '',
        loanPurpose: value,
      })
    } else {
      this.setState({
        url: loanAmount
          ? `${href}&loanAmount=${extractNumber(loanAmount)}&loanPurpose=${value}`
          : `${href}&loanPurpose=${value}`,
        loanPurpose: value,
      })
    }

    fireGtmEvent('fieldChange', { ...widgetContext, loanPurpose: value })
  }

  onClick = () => {
    const { widgetContext } = this.props
    const { loanAmount, loanPurpose } = this.state

    if (!validateLoanAmount(loanAmount)) {
      fireGtmEvent('ctaClick', { ...widgetContext, loanPurpose, loanAmount })
    }
  }
}

PersonalLoanForm.propTypes = {
  href: PropType.string.isRequired,
  widgetContext: PropType.object.isRequired,
  ctaText: PropType.string.isRequired,
  formData: PropType.object.isRequired,
}

export { PersonalLoanForm }

export default reduxForm({ form: 'personal-loan-form' })(PersonalLoanForm)
